<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}">
    <div class="position: relative;">
      <!-- .custom-company-example === cce -->
      <div class="cce">
        <div class="ccep-content">
          <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{Modal}}</div> -->
          <iSwitch size="large" v-model="Modal.isOpen">
            <span slot="open">开启</span>
            <span slot="close">关闭</span>
          </iSwitch>
          <a href="javascript:;" class="ccep-link" @click="linkTo()">上传</a>
          <span class="cce-info">点击{{ Modal.isOpen ? '关闭' : '开启'}}{{ Modal.title || '成功案例'}}</span>
          <div style="padding-top: 30px;">
            <Input v-model="Modal.title" placeholder="请输入标题" style="width: 100%" />
          </div>
          <div class="f-tar" style="margin-top:20px;">
            <Button type="primary" @click="saveCustom()" :loading="loading">保存</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"; 

export default {
  // 成功案例
  name: "custom-company-example",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          info: "成功案例",
          type: 7,
          isOpen: true,
          title: "成功案例"
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      visible: false
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    },
    currentSave(val, oldVal) {
      this.loading = val;
    }
  },
  computed: {
    type() {
      return this.Modal.config.type;
    },
    ...mapGetters({
      currentSave: "customCompanyModule/getCurrent",
      activeIndex: "customCompanyModule/getActiveIndex"
    })
  },
  created() {},
  methods: {
    ...mapMutations({
      setCurrent: "customCompanyModule/setCurrent",
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    linkTo() {
      const link = location.origin + "/#/exhibition/index/case/add";
      window.open(link);
    },
    saveCustom() {
      this.setCurrent(true);
    }
  } 
};
</script> 
<style scoped lang="scss">
.cce {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  .ccep {
    &-title {
      padding: 20px 30px;
      font-size: 14px;
      color: #333;
      border-bottom: solid 1px #ddd;
    }
    &-link {
      position: absolute;
      right: 20px;
      top: 20px;
    }
    &-content {
      padding: 40px 50px;
      .addlink {
        border: dashed 1px #bfbfbf;
        text-align: center;
        color: #1890ff;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
